import { TransferAssetSearchComponentBase } from './transfer-asset-search.component.base';
import { Component, Injector } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { FormStorage, UserStorage } from '@scisys-uim/uim-common';
import { AssetService, BusinessUnitService, CostCentreService, TransferAssetService } from 'assets-service';


@Component({
  selector: 'app-transfer-asset-search',
  templateUrl: './transfer-asset-search.component.html',
  styleUrls: ['./transfer-asset-search.component.scss']
})
export class TransferAssetSearchComponent extends TransferAssetSearchComponentBase {

  constructor(protected route: ActivatedRoute,
    protected router: Router,
    protected userStorage: UserStorage,
    protected dialog: MatDialog,
    protected transferAssetService: TransferAssetService,
    protected assetService: AssetService,
    protected businessUnitService: BusinessUnitService,
    protected costCentreService: CostCentreService,
    protected fb: FormBuilder,
    protected formStorage: FormStorage,
    protected injector: Injector) {
    super(route, router, userStorage, dialog, transferAssetService, assetService, businessUnitService, costCentreService, fb, formStorage, injector);
  }

  protected onInitAsyncComplete() {
    super.onInitAsyncComplete();
    this.businessUnitLoadSelectionList();
    this.costCentreLoadSelectionList();
    
    if (!this.restoreFormFromParams(this.searchForm)) {
      this.resetSearchForm();
      this.restoreFormChanges();
    }
  }
  
  resetSearchForm() {
    // placeholder
  }
  
  protected transformParamsToModelSetters(params: Params): {
    [key: string]: (value: any, formControl: FormControl, formControlName: string) => void
  } {
    return this.transformAllPropertiesToModelSetters();
  }
  
}



